export enum RecordingPolicy {
	ALLOW = 'Allow',
	DISABLE = 'Disable',
	REQUIRE = 'Require'
}
